import { render, staticRenderFns } from "./Reason.vue?vue&type=template&id=6c8eb976"
import script from "./Reason.vue?vue&type=script&lang=js"
export * from "./Reason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports